import {useQuery} from "@apollo/client";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {useTable} from "@/lib/hooks/useTable.ts";
import {GQL_MONITORING_SERVERS_LIST, MonitoringServersListResult} from "@/lib/queries/monitoring.ts";
import {MonitoringServerControlBar} from "@/pages/monitoring/monitoringservers/MonitoringServerControlBar.tsx";
import {MonitoringServersTable} from "@/pages/monitoring/monitoringservers/MonitoringServersTable.tsx";

const SESSION_STORAGE_FILTERS_KEY = "monitoring_servers_list_filters";

export const MonitoringServersList = () => {
  const {user} = useCurrentUserContext();

  const {
    search,
    searchDebounced,
    searchChanged,
    pagination,
    setPagination,
    sorting,
    sortingString,
    setSorting,
    filterSets,
    setFilterSets,
  } = useTable({
    sessionStorageKey: SESSION_STORAGE_FILTERS_KEY,
    resetPaginationOnFilter: true,
  });

  const {data, loading, previousData} = useQuery<MonitoringServersListResult>(GQL_MONITORING_SERVERS_LIST, {
    variables: {
      ...pagination,
      sort: sortingString,
      search: searchDebounced,
      filters: filterSets,
    },
  });

  const renderData = loading ? previousData : data;
  if (!renderData) {
    return <LoadingContainer />;
  }

  const billingType = user?.account?.subscription_type;
  const monitoringLevel = user?.account?.limit_monitoring_group_level;

  return (
    <>
      <MonitoringServerControlBar
        search={search}
        setSearch={searchChanged}
        filterSets={filterSets}
        onFilterSetChange={setFilterSets}
      />
      <MonitoringServersTable
        monitoringServers={renderData.monitoringServers.items}
        loading={loading}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={setSorting}
        billingType={billingType}
        monitoringLevel={monitoringLevel}
        pagination={pagination}
        updatePagination={setPagination}
        totalRows={renderData.monitoringServers.total}
        paginationData={renderData.monitoringServers.items}
      />
    </>
  );
};
